import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from './Footer';

const UA_MONTHS = ['Січень','Лютий','Березень','Квітень','Травень','Червень','Липень','Серпень','Вересень','Жовтень','Листопад','Грудень'];
const UA_DAYS = ['Пн','Вт','Ср','Чт','Пт','Сб','Нд'];

export default function TicketsPage() {
  const [prices, setPrices] = useState({ base_price: 150, child_price: 100, discount_price: 80, free_discount_price: 0, excursion_price: 500 });
  const [busyDates, setBusyDates] = useState([]);
  const [busySlots, setBusySlots] = useState([]);
  const [reservedDates, setReservedDates] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState('');
  const [visitType, setVisitType] = useState(''); // 'group' | 'individual'
  const [adults, setAdults] = useState(0);
  const [children, setChildren] = useState(0);
  const [discounts, setDiscounts] = useState(0);
  const [freeDiscounts, setFreeDiscounts] = useState(0);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');

  useEffect(() => {
    fetch('/api/settings/prices')
      .then(r => r.json())
      .then(d => setPrices(d))
      .catch(() => {});
    fetch('/api/excursions/busy')
      .then(r => r.json())
      .then(d => setBusyDates(d))
      .catch(() => {});
    fetch('/api/excursions/busy-slots')
      .then(r => r.json())
      .then(d => setBusySlots(d))
      .catch(() => {});
    fetch('/api/excursions/reserved-public')
      .then(r => r.json())
      .then(d => setReservedDates(d))
      .catch(() => {});
  }, []);

  const today = new Date();
  const todayStr = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,'0')}-${String(today.getDate()).padStart(2,'0')}`;

  const getDaysInMonth = (d) => new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
  const getFirstDayOfWeek = (d) => {
    const day = new Date(d.getFullYear(), d.getMonth(), 1).getDay();
    return day === 0 ? 6 : day - 1;
  };

  const daysInMonth = getDaysInMonth(currentMonth);
  const firstDay = getFirstDayOfWeek(currentMonth);
  const cells = [];
  for (let i = 0; i < firstDay; i++) cells.push(null);
  for (let i = 1; i <= daysInMonth; i++) cells.push(i);

  const dateKey = (day) => {
    const y = currentMonth.getFullYear();
    const m = String(currentMonth.getMonth() + 1).padStart(2, '0');
    const dd = String(day).padStart(2, '0');
    return `${y}-${m}-${dd}`;
  };

  const isPast = (key) => key < todayStr;
  const isWeekend = (day) => {
    const d = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day);
    const w = d.getDay();
    return w === 0 || w === 1; // Sunday or Monday
  };

  const selectableTimes = ['09:00','10:00','11:00','14:00','15:00'];
  const bookedTimesFor = (key) => busySlots.filter(s => s.date === key).map(s => s.time);
  const isFullyBlocked = (key) => {
    if (reservedDates.includes(key)) return true;
    const booked = bookedTimesFor(key);
    return selectableTimes.length > 0 && selectableTimes.every(t => booked.includes(t));
  };

  const prevMonth = () => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
  const nextMonth = () => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));

  const totalPeople = adults + children + discounts + freeDiscounts;
  const excursionCost = visitType === 'group' ? (prices.excursion_price || 0) : 0;
  const totalPrice = adults * prices.base_price + children * prices.child_price + discounts * prices.discount_price + freeDiscounts * (prices.free_discount_price || 0) + excursionCost;

  const canProceedTime = selectedDate && !isFullyBlocked(selectedDate) && !isPast(selectedDate);
  const canProceedType = canProceedTime && selectedTime;
  const canProceedGroup = visitType === 'group' && totalPeople >= 10;
  const canProceedIndividual = visitType === 'individual' && totalPeople > 0 && totalPeople <= 10;

  return (
    <>
    <div style={{ minHeight: '100vh', background: '#fff' }}>
      <div style={{ padding: '40px 60px', display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: '900px', margin: '0 auto' }}>
        <Link to="/" style={{ display: 'inline-block', marginBottom: '50px', marginTop: '20px', color: '#000', textDecoration: 'none', fontSize: '14px', textTransform: 'uppercase' }}>← Повернутись на головну</Link>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '20px' }}>Купити квиток</h1>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '15px', fontSize: '14px' }}>
          <span style={{ width: '10px', height: '10px', borderRadius: '50%', background: 'red', display: 'inline-block' }}></span>
          <span>— заброньовані дати на відвідування музею</span>
        </div>
        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', marginBottom: '15px', fontSize: '13px', padding: '10px 14px', background: '#f5f5f5', borderRadius: '6px' }}>
          <span><strong>Дорослий:</strong> {prices.base_price} грн</span>
          <span><strong>Дитячий:</strong> {prices.child_price} грн</span>
          <span><strong>Пільговий:</strong> {prices.discount_price} грн</span>
          <span><strong>Пільговий безкоштовний:</strong> {prices.free_discount_price} грн</span>
          <span><strong>Вартість екскурсії:</strong> {prices.excursion_price} грн</span>
        </div>
        <div style={{ marginBottom: '30px', fontSize: '13px', lineHeight: 1.6, color: '#444' }}>
          <p style={{ fontWeight: 700, marginBottom: '6px' }}>Право на придбання пільгового квитка мають:</p>
          <p>Пенсіонери; Студенти.</p>
          <p style={{ fontWeight: 700, marginTop: '10px', marginBottom: '6px' }}>Право на безкоштовне відвідування музею мають:</p>
          <p>Учасники бойових дій; Ветерани війни — особи з інвалідністю внаслідок війни; Особи з інвалідністю I групи внаслідок загального захворювання; Діти віком до 3 років; Діти-сироти, діти, позбавлені батьківського піклування, діти, які перебувають під опікою, та діти загиблих учасників бойових дій; Працівники музеїв та заповідників; Члени Національної спілки краєзнавців України; Члени міжнародних організацій ICOM (Міжнародна рада музеїв) та ICOMOS (Міжнародна рада з охорони пам’яток та історичних місць).</p>
          <p style={{ marginTop: '10px', fontStyle: 'italic' }}>Примітка: Пільгове та безкоштовне відвідування здійснюється за умови пред’явлення документа, що підтверджує належність до відповідної категорії.</p>
        </div>

        {/* Calendar */}
        <div style={{ maxWidth: '720px', marginBottom: '40px', width: '100%' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <button onClick={prevMonth} style={{ padding: '8px 16px', cursor: 'pointer', background: '#000', color: '#fff', border: 'none' }}>◀</button>
            <h2 style={{ fontSize: '1.5rem' }}>{UA_MONTHS[currentMonth.getMonth()]} {currentMonth.getFullYear()}</h2>
            <button onClick={nextMonth} style={{ padding: '8px 16px', cursor: 'pointer', background: '#000', color: '#fff', border: 'none' }}>▶</button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '8px', textAlign: 'center' }}>
            {UA_DAYS.map(d => <div key={d} style={{ fontWeight: 600, padding: '8px', fontSize: '14px' }}>{d}</div>)}
            {cells.map((day, idx) => {
              if (day === null) return <div key={idx} />;
              const key = dateKey(day);
              const past = isPast(key);
              const weekend = isWeekend(day);
              const fullyBlocked = isFullyBlocked(key);
              const selected = selectedDate === key;
              const disabled = past || fullyBlocked || weekend;
              return (
                <div
                  key={idx}
                  onClick={() => { if (!disabled) { setSelectedDate(key); setSelectedTime(''); setVisitType(''); } }}
                  style={{
                    padding: '12px',
                    borderRadius: '4px',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    background: selected ? '#000' : (past || weekend || fullyBlocked ? '#f0f0f0' : '#fff'),
                    color: selected ? '#fff' : (past || weekend || fullyBlocked ? '#bbb' : '#000'),
                    border: '1px solid #ddd',
                    position: 'relative',
                    opacity: (past || weekend || fullyBlocked) ? 0.5 : 1,
                  }}
                >
                  {day}
                  {fullyBlocked && <span style={{ position: 'absolute', bottom: '2px', left: '50%', transform: 'translateX(-50%)', width: '6px', height: '6px', borderRadius: '50%', background: 'red' }} />}
                </div>
              );
            })}
          </div>
        </div>

        {/* Time selection */}
        {canProceedTime && (
          <div style={{ marginBottom: '40px', maxWidth: '720px', width: '100%' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '15px' }}>Оберіть час відвідування</h2>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              {['09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00'].map(t => {
                const disabled = ['12:00','13:00','16:00'].includes(t) || busySlots.some(s => s.date === selectedDate && s.time === t);
                return (
                <button
                  key={t}
                  onClick={() => { if (!disabled) setSelectedTime(t); }}
                  style={{
                    padding: '10px 20px',
                    background: disabled ? '#f0f0f0' : (selectedTime === t ? '#000' : '#fff'),
                    color: disabled ? '#bbb' : (selectedTime === t ? '#fff' : '#000'),
                    border: '1px solid #ddd',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    opacity: disabled ? 0.5 : 1,
                  }}
                >
                  {t}
                </button>
                );
              })}
            </div>
          </div>
        )}

        {/* Visit type */}
        {canProceedType && (
          <div style={{ marginBottom: '40px', maxWidth: '720px', width: '100%' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '15px' }}>Тип відвідування</h2>
            <div style={{ display: 'flex', gap: '20px' }}>
              <button
                onClick={() => setVisitType('group')}
                style={{
                  padding: '15px 30px',
                  background: visitType === 'group' ? '#000' : '#fff',
                  color: visitType === 'group' ? '#fff' : '#000',
                  border: '1px solid #000',
                  cursor: 'pointer',
                }}
              >
                Групова екскурсія
              </button>
              <button
                onClick={() => setVisitType('individual')}
                style={{
                  padding: '15px 30px',
                  background: visitType === 'individual' ? '#000' : '#fff',
                  color: visitType === 'individual' ? '#fff' : '#000',
                  border: '1px solid #000',
                  cursor: 'pointer',
                }}
              >
                Індивідуальне відвідування
              </button>
            </div>
          </div>
        )}

        {/* Group form */}
        {visitType === 'group' && (
          <div style={{ marginBottom: '40px', maxWidth: '720px', width: '100%' }}>
            <p style={{ marginBottom: '15px', fontStyle: 'italic' }}>Групова екскурсія — мінімум 10 осіб</p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '15px', marginBottom: '20px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '5px' }}>Дорослі</label>
                <input type="number" min="0" value={adults} onChange={(e) => setAdults(parseInt(e.target.value) || 0)} style={{ width: '100%', padding: '10px', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '5px' }}>Дитячі</label>
                <input type="number" min="0" value={children} onChange={(e) => setChildren(parseInt(e.target.value) || 0)} style={{ width: '100%', padding: '10px', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '5px' }}>Пільгові</label>
                <input type="number" min="0" value={discounts} onChange={(e) => setDiscounts(parseInt(e.target.value) || 0)} style={{ width: '100%', padding: '10px', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '5px' }}>Пільгові безкоштовні</label>
                <input type="number" min="0" value={freeDiscounts} onChange={(e) => setFreeDiscounts(parseInt(e.target.value) || 0)} style={{ width: '100%', padding: '10px', boxSizing: 'border-box' }} />
              </div>
            </div>
            <div style={{ marginBottom: '10px' }}>Загальна кількість: <strong>{totalPeople}</strong></div>
            <div style={{ marginBottom: '10px' }}>Вартість екскурсії: <strong>{prices.excursion_price || 0} грн</strong></div>
            <div style={{ marginBottom: '20px', fontSize: '1.25rem' }}>Фінальна вартість: <strong>{totalPrice} грн</strong></div>
            {totalPeople < 10 && <p style={{ color: 'red', marginBottom: '15px' }}>Мінімум 10 осіб для групової екскурсії</p>}
          </div>
        )}

        {/* Individual form */}
        {visitType === 'individual' && (
          <div style={{ marginBottom: '40px', maxWidth: '720px', width: '100%' }}>
            <p style={{ marginBottom: '15px', fontStyle: 'italic' }}>Індивідуальне відвідування — до 10 осіб</p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '15px', marginBottom: '20px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '5px' }}>Дорослі</label>
                <input type="number" min="0" value={adults} onChange={(e) => setAdults(parseInt(e.target.value) || 0)} style={{ width: '100%', padding: '10px', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '5px' }}>Дитячі</label>
                <input type="number" min="0" value={children} onChange={(e) => setChildren(parseInt(e.target.value) || 0)} style={{ width: '100%', padding: '10px', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '5px' }}>Пільгові</label>
                <input type="number" min="0" value={discounts} onChange={(e) => setDiscounts(parseInt(e.target.value) || 0)} style={{ width: '100%', padding: '10px', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '5px' }}>Пільгові безкоштовні</label>
                <input type="number" min="0" value={freeDiscounts} onChange={(e) => setFreeDiscounts(parseInt(e.target.value) || 0)} style={{ width: '100%', padding: '10px', boxSizing: 'border-box' }} />
              </div>
            </div>
            <div style={{ marginBottom: '10px' }}>Загальна кількість: <strong>{totalPeople}</strong></div>
            <div style={{ marginBottom: '20px', fontSize: '1.25rem' }}>Фінальна вартість: <strong>{totalPrice} грн</strong></div>
            {totalPeople > 10 && <p style={{ color: 'red', marginBottom: '15px' }}>Максимум 10 осіб для індивідуального відвідування</p>}
          </div>
        )}

        {/* Contact & buy */}
        {(canProceedGroup || canProceedIndividual) && (
          <div style={{ marginBottom: '40px', maxWidth: '720px', width: '100%' }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '15px' }}>Контактні дані</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '20px' }}>
              <input type="text" placeholder="ПІБ" value={name} onChange={(e) => setName(e.target.value)} style={{ padding: '10px', width: '100%', boxSizing: 'border-box' }} required />
              <input type="tel" placeholder="+380" value={phone} onChange={(e) => {
                let v = e.target.value;
                if (!v.startsWith('+380')) v = '+380' + v.replace(/^\+?3?8?0?/, '');
                setPhone(v);
              }} style={{ padding: '10px', width: '100%', boxSizing: 'border-box' }} required />
            </div>
            <button
              onClick={() => {
                const orderId = 'GM-' + Math.floor(10000 + Math.random() * 90000);
                const data = {
                  token: '3f4f0566-89d9-4ce3-8b20-5786c1b9956b',
                  sum: String(totalPrice),
                  parameters: {
                    FIO: name,
                    PHONE: phone,
                    DEST: 'Оплата за вхідний квиток №' + orderId + ' від ' + name + ', тел: ' + phone + ', ' + (visitType === 'group' ? 'Групова екскурсія' : 'Індивідуальне відвідування') + ', ' + [adults > 0 ? 'дорослі: ' + adults : '', children > 0 ? 'дитячі: ' + children : '', discounts > 0 ? 'пільгові: ' + discounts : '', freeDiscounts > 0 ? 'пільгові безкоштовні: ' + freeDiscounts : ''].filter(Boolean).join(', '),
                  },
                };
                // Save order to DB
                fetch('/api/orders', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    order_number: orderId,
                    date: selectedDate,
                    time: selectedTime,
                    visit_type: visitType === 'group' ? 'Групова екскурсія' : 'Індивідуальне відвідування',
                    excursion_cost: visitType === 'group' ? (prices.excursion_price || 0) : 0,
                    adults, children, discounts, free_discounts: freeDiscounts,
                    total_sum: totalPrice,
                    name, phone,
                  }),
                }).catch(() => {});
                const paymentUrl = 'https://next.privat24.ua/payments/form/' + encodeURIComponent(JSON.stringify(data));
                window.location.href = paymentUrl;
              }}
              disabled={!name || !phone}
              style={{
                padding: '15px 40px',
                background: name && phone ? '#000' : '#ccc',
                color: '#fff',
                border: 'none',
                cursor: name && phone ? 'pointer' : 'not-allowed',
                fontSize: '1.1rem',
              }}
            >
              Купити квиток
            </button>
          </div>
        )}
      </div>
    </div>
    <Footer />
    </>
  );
}
